export default __webpack_public_path__ + "static/media/cashapp.f0f35654.svg";